import React, { memo } from 'react';
import { LottieGif } from '@Sage/ssm-web5';
import SageLogo from 'assets/logo-SSMAdmin.svg';
import lottieSageLoader from '../lottieFiles/sage_crm_loader.json';

const styles = {
    position: 'fixed',
    top: 0,
    width: '100%',
    height: '100%',
    zIndex: 9999,
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
};

const bottomLogoStyles = {
    position: 'fixed',
    bottom: '10%',
};

const TabLoader = () => {
    return (
        <div style={styles}>
            <LottieGif width="200px" height="200px" src={lottieSageLoader} />
            <div style={bottomLogoStyles}>
                <SageLogo aria-label="Logo" width={300} />
            </div>
        </div>
    );
};

export default memo(TabLoader);
